import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'

import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import { ConfigurationAutomaticCustomerRuleSetCreateRequest, ConfigurationAutomaticCustomerRuleSetPatchInBatchRequest, ConfigurationAutomaticCustomeRuleSetResponse } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/automatic-customer-rule-set-services/automatic-customer-rule-set-services.dto'

class ConfigurationLocalAccountingBillableCustomerRuleSetService {
    async create(laboratoryId: number, request: ConfigurationAutomaticCustomerRuleSetCreateRequest): Promise<ConfigurationAutomaticCustomeRuleSetResponse> {
        const response = await axios.post<ConfigurationAutomaticCustomeRuleSetResponse>(
            `/configuration/laboratories/${laboratoryId}/automaticCustomerRuleSets`,
            request
        )
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationAutomaticCustomeRuleSetResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationAutomaticCustomeRuleSetResponse>>(
            `/configuration/laboratories/${laboratoryId}/automaticCustomerRuleSets`,
            { ...filterModel },
            { params }
        )
        return response.data
    }

    async get(laboratoryId: number, automaticCustomerRuleSetId: number): Promise<ConfigurationAutomaticCustomeRuleSetResponse> {
        const response = await axios.get<ConfigurationAutomaticCustomeRuleSetResponse>(
            `/configuration/laboratories/${laboratoryId}/automaticCustomerRuleSets/${automaticCustomerRuleSetId}`
        )
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(
            `/configuration/laboratories/${laboratoryId}/automaticCustomerRuleSets/batch`, { data: request }
        )
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationAutomaticCustomerRuleSetPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(
            `/configuration/laboratories/${laboratoryId}/automaticCustomerRuleSets/batch`,
            request
        )
        return response.data
    }
}

export const configurationLocalAccountingBillableCustomerRuleSetService = new ConfigurationLocalAccountingBillableCustomerRuleSetService()
